import React, { useState } from 'react';

const ForumSections = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [suggestions, setSuggestions] = useState([]);

  const popularTopics = [
    "Scratch", "micro:bit", "robotique", "paiement", 
    "devenir tuteur", "Arduino", "impression 3D", 
    "programmation", "électronique", "fablab"
  ];

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
    
    if (value.length > 1) {
      const filteredSuggestions = popularTopics.filter(topic =>
        topic.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filteredSuggestions);
    } else {
      setSuggestions([]);
    }
  };

  const handleSuggestionClick = (suggestion) => {
    setSearchQuery(suggestion);
    setSuggestions([]);
  };

  const forumSections = [
    {
      id: 1,
      title: "Bienvenue & Présentations",
      description: "Dis bonjour, raconte qui tu es et découvre les autres membres.",
      icon: "👋",
      color: "bg-purple-3",
      textColor: "text-purple-1"
    },
    {
      id: 2,
      title: "Projets Makers",
      description: "Partage tes créations (jeux, robots, prototypes), demande des retours et inspire la communauté.",
      icon: "🛠️",
      color: "bg-light-2",
      textColor: "text-blue-1"
    },
    {
      id: 3,
      title: "Apprentissage & Tutorat",
      description: "Questions sur les parcours, échanges de conseils entre apprenants et tuteurs.",
      icon: "🎓",
      color: "bg-light-6",
      textColor: "text-red-2"
    },
    {
      id: 4,
      title: "Ateliers & Événements",
      description: "Infos sur les prochains ateliers en ligne et dans les fablabs partenaires, retours d'expérience et photos.",
      icon: "📅",
      color: "bg-light-3",
      textColor: "text-dark-1"
    },
    {
      id: 5,
      title: "Questions & Entraide",
      description: "Un espace d'assistance entre membres sur les aspects techniques, pratiques ou organisationnels.",
      icon: "🆘",
      color: "bg-red-3",
      textColor: "text-red-4"
    },
    {
      id: 6,
      title: "Discussions Libres",
      description: "Pour parler d'innovations, d'actualité tech ou simplement échanger autour de vos passions.",
      icon: "💬",
      color: "bg-green-1",
      textColor: "text-dark-2",
      bgOpacity: "bg-opacity-20"
    }
  ];

  return (
    <section className="py-12 px-4 md:px-8 lg:px-16 bg-light-4">
      <div className="max-w-7xl mx-auto">
        {/* Barre de recherche */}
        <div className="mb-12 relative max-w-2xl mx-auto">
          <div className="relative">
            <input
              type="text"
              value={searchQuery}
              onChange={handleSearchChange}
              placeholder="Rechercher une discussion ou un projet…"
              className="w-full px-6 py-4 rounded-2xl border-2 border-light-3 focus:border-purple-1 focus:outline-none font-sans text-normal text-dark-1 shadow-sm"
            />
            <svg 
              className="absolute right-4 top-1/2 transform -translate-y-1/2 w-6 h-6 text-dark-3" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </div>
          
          {suggestions.length > 0 && (
            <div className="absolute z-10 w-full mt-1 bg-white rounded-2xl shadow-lg border border-light-3 overflow-hidden">
              {suggestions.map((suggestion, index) => (
                <div
                  key={index}
                  onClick={() => handleSuggestionClick(suggestion)}
                  className="px-6 py-3 cursor-pointer hover:bg-light-3 font-sans text-normal text-dark-1"
                >
                  {suggestion}
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Espaces du forum */}
        <h2 className="text-title font-bold text-dark-1 text-center mb-2 font-sans">
          Espaces principaux du Forum
        </h2>
        <p className="text-light-1 text-center mb-10 font-sans text-normal max-w-3xl mx-auto">
          Découvrez les différents espaces de discussion et choisissez celui qui correspond à vos besoins
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {forumSections.map((section) => (
            <div 
              key={section.id} 
              className={`rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow duration-300 ${section.color} ${section.bgOpacity || ''} border border-white`}
            >
              <div className="flex items-start mb-4">
                <span className="text-3xl mr-4">{section.icon}</span>
                <h3 className={`text-lg font-bold font-sans ${section.textColor}`}>
                  {section.title}
                </h3>
              </div>
              <p className="text-light-1 font-sans text-normal">
                {section.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ForumSections;